<template>
</template>
<script>
    import PreviewElement from "./PreviewElement";
    import InputElement from "../../components/pagesbuilder/elements/InputElement";

    export default {
        name: "PreviewInputElement",
        mixins: [
            PreviewElement,
            InputElement
        ],
        data() {
            return {}
        },
    }
</script>
